import React, { useState } from 'react';
import { getDisplayName } from '../../utils/admin';
import { Avatar } from '../Avatar';
import { Icon } from '../Icon';
import { DeviceIcons } from '../PresenceIcons';
import { presenceText } from '../../utils/presence';

export function ReplyingBanner({ replyingTo, onCancel }) {
    return (
        <div className="reply-banner">
            <span className="reply-banner-text">
                <strong>{getDisplayName(replyingTo.username)}</strong>님에게 답장 · <em>{replyingTo.message.substring(0, 40)}</em>
            </span>
            <button className="reply-banner-cancel" onClick={onCancel} aria-label="답장 취소"><Icon name="x" size={16} /></button>
        </div>
    );
}

const UserItem = ({ user, onMention }) => {
    const status = user.isOnline === false ? 'offline' : (user.status || 'online');
    const detail = presenceText(user);
    return (
        <li className={`member-item${user.isOnline === false ? ' offline' : ''}`} onClick={() => onMention?.(user)} title={`@${user.username} 멘션 · ${detail}`}>
            <Avatar className="member-avatar" userId={user.userId} name={user.username}><span className={`member-dot status-${status}`} /></Avatar>
            <span className="member-text">
                <span className="member-name">{user.username}</span>
                {user.isOnline !== false && <span className="member-status">{detail}</span>}
            </span>
            {user.isOnline !== false && <DeviceIcons devices={user.devices} />}
        </li>
    );
};

// 접속자 패널 (PC: 오른쪽 패널, 모바일: 오른쪽에서 열리는 서랍)
export function UserList({ users, systemMessages = [], open, onClose, onMentionUser, width, channelName }) {
    const [offlineOpen, setOfflineOpen] = useState(false);
    const online = users.filter(u => u.isOnline !== false);
    const counts = online.reduce((acc, u) => { acc[u.status || 'online'] = (acc[u.status || 'online'] || 0) + 1; return acc; }, {});
    const offline = users.filter(u => u.isOnline === false);

    return (
        <>
            {open && <div className="drawer-backdrop member-backdrop" onClick={onClose} />}
            <aside className={`member-panel${open ? ' open' : ''}`} style={width ? { '--panel-width': `${width}px` } : undefined}>
                <div className="panel-head">
                    <div className="member-panel-title">
                        <span className="member-panel-channel">{channelName ? `# ${channelName}` : '멤버'}</span>
                        <span className="member-panel-count">
                            {online.length} 접속{counts.idle ? ` · 자리 비움 ${counts.idle}` : ''}{counts.dnd ? ` · 방해 금지 ${counts.dnd}` : ''}{offline.length ? ` · ${offline.length} 오프라인` : ''}
                        </span>
                    </div>
                    <button className="nav-icon-btn" onClick={onClose} aria-label="접속자 패널 닫기"><Icon name="x" /></button>
                </div>
                <div className="member-scroll">
                    {online.length > 0 && <div className="member-section">접속 중 — {online.length}</div>}
                    <ul className="member-list">{online.map(u => <UserItem key={u.userId} user={u} onMention={onMentionUser} />)}</ul>
                    {offline.length > 0 && (
                        <>
                            <button className="member-section toggle" onClick={() => setOfflineOpen(v => !v)}>
                                {offlineOpen ? '▾' : '▸'} 오프라인 — {offline.length}
                            </button>
                            {offlineOpen && <ul className="member-list">{offline.map(u => <UserItem key={u.userId} user={u} onMention={onMentionUser} />)}</ul>}
                        </>
                    )}
                    {systemMessages.length > 0 && (
                        <details className="activity-log">
                            <summary>최근 활동</summary>
                            <ul>
                                {systemMessages.map((m, i) => (
                                    <li key={i}>{m.text}<span className="activity-time">{new Date(m.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span></li>
                                ))}
                            </ul>
                        </details>
                    )}
                </div>
            </aside>
        </>
    );
}
